
import { defineComponent } from "vue";
import SettlementEntityHistoricalInfomation from "@/components/page/kyc/settlement-entity/HistoricalInformation.vue";

export default defineComponent({
  name: "settlement-entity-natural-person-historical-information",
  components: {
    SettlementEntityHistoricalInfomation,
  },
  setup() {
    return {};
  },
});
